import React, { useState, useEffect } from "react";
import { orderCount, approveOrder, cancelOrder, allOrders, getOrdersForSubsite } from '../../reducers/orders';
import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Pagination from 'react-bootstrap/Pagination';
import MSMPagination from '../MSMPagination';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const columns = [
    { name: 'id', header: 'Order ID', defaultFlex: 1 },
    { name: 'items', header: 'Items', defaultFlex: 1,
        render: ({ data }) => (
            data.order_items.map(item => (
                <>{item.sizeName}<br/ ></>
            ))
        ) },
  { name: 'deliveryName', header: 'deliveryName', maxWidth: 1000, defaultFlex: 4 },
];

const gridStyle = { minHeight: 550 }


const AdminOrders = () => {
  const orders = useSelector(allOrders);
  const orderCnt = useSelector(orderCount);
  const orderStatus = useSelector(state => state.orders.status);
  const approveStatus = useSelector(state => state.orders.approveStatus);
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [filter, setFilter] = useState("open");
  const [cancelOrderId, setCancelOrderId] = useState(0);
  const [resetPagination, setResetPagination] = useState(false);
  
  let perPage = 10;

  const handleClose = () => setShow(false);

  const handleShow = (orderId) => {
    console.log("ORDER ID", orderId);
    setShow(true);
    setCancelOrderId(orderId);
  };

  useEffect(() => {
    if(orderStatus === 'idle') {
        const range = [ filter, 1, perPage ];
        dispatch(getOrdersForSubsite(range));
    }
}, [orderStatus, dispatch]);

  useEffect(() => {
    const range = [ filter, 1, perPage ];
    dispatch(getOrdersForSubsite(range));
  }, [filter, dispatch]);

  const cancelOrderClick = () => {
    dispatch(cancelOrder(cancelOrderId));
    setShow(false);
  }

  const approveOrderClick = (event, orderId) => {
    event.target.disabled = true;
    dispatch(approveOrder(orderId));
    setShow(false);
    event.target.disabled = false;
  }

  let content = "";

  if (orderStatus === 'loading') {
    content = <Spinner text="Loading..." />
  } else if (orderStatus === 'succeeded') {
  } else if (orderStatus === 'failed') {
    content = <div>error</div>
  }

  if (orderStatus === 'loading') {
    content = <Spinner text="Loading..." />
  } else if (orderStatus === 'succeeded') {
    console.log("Orders", orders);
  } else if (orderStatus === 'failed') {
    content = <div>error</div>
  }


  const filterChanged = (event) => {
    console.log(event.target.value);
    setFilter(event.target.value);
    setResetPagination(!resetPagination);
  }

  const reloadData = (range) => {
    const params = [ filter, range[0], range[1] ];
    dispatch(getOrdersForSubsite(params));
  }

  return (
    <>
    <h2>Orders</h2>
    <MSMPagination reload={reloadData} perPage={perPage} total={orderCnt} reset={resetPagination} />

    <div>
    <Form.Select aria-label="Default select example" onChange={filterChanged}>
      <option value="open">Open</option>
      <option value="approved">Approved</option>
      <option value="Closed">Closed</option>
      <option value="Cancelled">Cancelled</option>
    </Form.Select>

    </div>
    {orders.length > 0 && orders.map(order => {
        let total = 0;
        let totalCount = 0;
        let items = [];
        console.log(order);
        order.order_items.map(item => {
          total += (item.price * item.quantity);
          totalCount += item.quantity;
          items.push(
          <div className="adminOrder">
                              <Container fluid>
                                <Row>
                                  <Col>
                                    <img src={item.product?.frontModelImage} height={'50'}></img>
                                  </Col>                                 
                                  <Col xs={6}>
                                    {item.product?.style.title}
                                  </Col>                                 
                                  <Col className="color">
                                  {item.colorName}
                                  </Col>                                 
                                  <Col className="size-name">
                                  {item.sizeName}
                                  </Col>                                 
                                  <Col className="quantity">
                                  {item.quantity}
                                  </Col>                                 
                                  <Col className="price">
                                  {(item.price * item.quantity).toLocaleString(undefined, { style: "currency", currency: "USD"})}
                                  </Col>                                 
                                </Row>
                                <Row>
                                  <Col>
                                    {item.subsite_decorations?.map(logo => {
                                      console.log("LOGO IN DECORATION", logo);
                                      return logo.decoration_logo.decorationName + " - " + logo.deco_location.description;
                                    })}
                                  </Col>
                                </Row>
                              </Container>
          </div>);
        });
        return (
        <div className="admin-order-container">
            {order.newHireKit && (
              <div className="header" style={{backgroundColor: "#66FF66", padding: 10}}>
                <span style={{fontWeight: "bold"}} >New Hire Kit</span>
              </div>
            )}
            <div className="header">
                <div><span className="caption">Date Placed</span><br />{new Date(order.placed).toLocaleDateString('en-us', { year:"numeric", month:"short", day:"numeric"}) }</div>
                <div><span className="caption">Total</span><br />{order.orderCost.toLocaleString(undefined, { style: "currency",
  currency: "USD",})}</div>
                <div><span className="caption">Delivery Name</span><br />{order.deliveryName}</div>
                <div><span className="caption">Balance</span><br />{order.orderedBy?.balance}</div>
                <div><span className="caption">Ordered By</span><br />{order.orderedBy?.lastname}, {order.orderedBy?.firstname}</div>
                <div><span className="caption">Order #</span><br />{order.id}</div>
                <div><span className="caption">Status</span><br />{order.status.toUpperCase()}</div>
            </div>
            <div>
              {items}
            </div>
            <div className="total">Total ({totalCount} items): <strong>{order.orderCost.toLocaleString(undefined, { style: "currency",
  currency: "USD",})}</strong></div>
            <div className="total">
            {order.status === 'open' ? (
                <>
                  <Button variant="danger" onClick={() => handleShow(order.id)}>Cancel Order</Button> 
                  <Button variant="success" onClick={(event) => approveOrderClick(event, order.id)}>Approve Order</Button>
                </>
            ) : null }
            </div>
        </div>
        );
    })}

    {orders.length == 0 && (
        <div>No Orders</div>
    )
    }
    <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Cancel Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to cancel Order # {cancelOrderId} </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={cancelOrderClick}>
            Cancel the Order
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default AdminOrders;

